import classNames from 'classnames';
import React, { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';
import {
  getSelectChipVariantStyle,
  select_chip_base_css,
  select_chip_icon_size_css,
  select_chip_size_css,
} from './styles';
import { IconCircleQuestion, IconProps } from '../icons/generated';
import { semantic_colors } from '../../foundation';

export type SelectChipVariant = 'filled' | 'outlined';
export type SelectChipSize = 'xsmall' | 'medium';

export interface SelectChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'children'> {
  label: string;
  /** @default 'outlined' */
  variant?: SelectChipVariant;
  /** @default 'xsmall' */
  size?: SelectChipSize;
  selected?: boolean;
  /** label 좌측 렌더링될 Icon (size는 SelectChip의 size에 맞춰 고정, color는 currentColor로 고정) */
  leftIcon?: ReactElement<IconProps>;
  helperIcon?: (icon: ReactNode) => ReactElement;
}

export const SelectChip = React.forwardRef<HTMLButtonElement, SelectChipProps>(
  (
    { label, variant = 'outlined', size = 'xsmall', selected, disabled, className, leftIcon, helperIcon, ...props },
    ref,
  ) => {
    const icon_size = select_chip_icon_size_css[size];
    const helper_icon_color =
      variant === 'filled' && selected ? semantic_colors.static.white : semantic_colors.content.tertiary;

    return (
      <button
        type='button'
        className={classNames('pds-select-chip', className)}
        css={[select_chip_base_css, select_chip_size_css[size], getSelectChipVariantStyle(variant, !!selected)]}
        disabled={disabled}
        {...props}
        ref={ref}
      >
        {leftIcon && React.cloneElement(leftIcon, { size: icon_size, color: 'currentColor' })}
        {label}
        {helperIcon &&
          helperIcon(
            <div style={{ lineHeight: 0 }}>
              <IconCircleQuestion width={12} height={12} color={helper_icon_color} />
            </div>,
          )}
      </button>
    );
  },
);
